import type { ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';
import type { ICatalogItem, NegotiationType } from '@/types/commercial/cart';

export interface CatalogQueryParams {
  negotiationType?: NegotiationType;
  category?: string;
  search?: string;
}

export const catalogApi = {
  findMany: async (params?: CatalogQueryParams): Promise<ICatalogItem[]> => {
    const queryParams: Record<string, string> = {};

    if (params?.negotiationType) queryParams.negotiationType = params.negotiationType;
    if (params?.category) queryParams.category = params.category;
    if (params?.search) queryParams.search = params.search;

    const { data } = await api.get<ApiResponse<ICatalogItem[]>>('/commercial/catalog', {
      params: queryParams,
    });

    return data.data;
  },
};
